
import { defineComponent } from "vue";

export default defineComponent({
  name: "HomeWithLogin",
  props: {
    msg: String,
  },
});
